// Configuration utility for environment-specific URLs
export const getPublicUrl = () => {
  return process.env.REACT_APP_PUBLIC_URL || 'https://urlmonitor.pro';
};

export const getCanonicalUrl = (path = '') => {
  const baseUrl = getPublicUrl();
  return `${baseUrl}${path}`;
};

export const getOgImageUrl = () => {
  return `${getPublicUrl()}/og-image.png`;
};
